var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OneTable',{attrs:{"mainHeader":'בוצע',"postState":'done',"trucking":_vm.trucking}})}
var staticRenderFns = []

export { render, staticRenderFns }